import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  formatPrice,
  customStyle,
  getSystemSettings,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import Select from "react-select";
import moment from 'moment';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { UserContext } from "../../../../contexts/User";
import CustomSpinLoader from "../../../components/CustomSpinLoader";

const StockConsumptionPurchaseVarianceReport = () => {
    const { t } = useTranslation();
    const history = useHistory();
    //getting context values here
    let { loading, setLoading, dataPaginating, generalSettings } =
      useContext(SettingsContext);
    let { branchForSearch, ingredientItemForSearch, ingredientGroupForSearch, getIngredientGroup } = useContext(RestaurantContext);
    const { authUserInfo } = useContext(UserContext);
  
    let [newReportFilter, setNewReportFilter] = useState({
      branch: null,
      item: null,
      group: null
    });
    
    //all data
    const [reportData, setReportData] = useState(null);
  
    const componentRef = useRef();
    const componentRefThermal = useRef();
    //settle order
    const [startDate, setStartDate] = useState(null);
    const [generatedReport, setGeneratedReport] = useState(false);
    const [siteName, setSiteName] = useState("");
    // const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
    //useEffect == componentDidMount()
    const [branchSearch, setBranchSearch] = useState(null);
  
    useEffect(() => {
      if(!generalSettings){
        return;
      }
      setSiteName(getSystemSettings(generalSettings, "siteName"));
      if (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") {
        setBranchSearch(
          branchForSearch.filter(
            (branch) => branch.id === authUserInfo.details.branch_id
          )
        );
      } else {
        setBranchSearch(branchForSearch);
      }
      if(!ingredientGroupForSearch){
        getIngredientGroup();
      }
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }, [generalSettings]);

    const handleBranch = (branch) => {
      setNewReportFilter({
        ...newReportFilter,
        branch: branch,
      });
    };

    const handleGroup = (group)=>{
      setNewReportFilter({
        ...newReportFilter,
        group: group,
      });
    }

    const handleItem = (item) => {
      setNewReportFilter({
        ...newReportFilter,
        item: item,
      });
    };

    const thermalPrint = useReactToPrint({
      content: () => componentRefThermal.current,
      pageStyle: `
        @page {
          margin: 15px;
        }
      `,
    });

    const formatTwoDecimal = (value) => {
      if (value === null || value === undefined || value === "") {
        return "0.00";
      }
      const num = Number(value);
      if (isNaN(num)) {
        return value;
      }
      const [intPart, decPart = ""] = String(num).split(".");
      return `${intPart}.${(decPart + "00").slice(0, 2)}`;
    };

    const getLastPurchaseRate = (record) => {
      return parseFloat(
        record.last_purchase_rate ??
        record.last_purchase_price ??
        record.purchase_rate ??
        record.last_rate ??
        record.avg_rate ??
        record.rate ??
        0
      ) || 0;
    };


    /* sorting logic start
    const getNumericValue = (record, key) => {
      switch (key) {
        case "consumption_qty":
          return parseFloat(record.consumption_qty) || 0;
        case "consumption_qty_default":
          return parseFloat(record.consumption_qty_default) || 0;
        case "purchase_qty":
          return parseFloat(record.purchase_qty) || 0;
        case "purchase_qty_default":
          return parseFloat(record.purchase_qty_default) || 0;
        case "variance_qty":
          return parseFloat(record.variance_qty_default ?? record.variance_qty) || 0;
        case "variance_value":
          return parseFloat(record.variance_value) || 0;
        case "variance_percent":
          return parseFloat(record.variance_percent) || 0;
        default:
          return 0;
      }
    };

    const flattenReportRows = () => {
      const rows = [];
      if (!reportData) {
        return rows;
      }
      reportData.forEach((groupObj) => {
        Object.keys(groupObj).forEach((groupName) => {
          const itemsArray = groupObj[groupName];
          itemsArray.forEach((itemObj) => {
            Object.keys(itemObj).forEach((itemName) => {
              itemObj[itemName].forEach((record) => {
                rows.push({ groupName, itemName, record });
              });
            });
          });
        });
      });
      return rows;
    };

    const getSortedViewRows = () => {
      const rows = flattenReportRows();
      if (!sortConfig.key) {
        return rows;
      }
      const direction = sortConfig.direction === "desc" ? -1 : 1;
      return [...rows].sort((a, b) => {
        const aVal = getNumericValue(a.record, sortConfig.key);
        const bVal = getNumericValue(b.record, sortConfig.key);
        if (aVal < bVal) return -1 * direction;
        if (aVal > bVal) return 1 * direction;
        return 0;
      });
    };

    const handleSort = (key) => {
      setSortConfig((prev) => {
        if (prev.key === key) {
          if (prev.direction === "asc") {
            return { key, direction: "desc" };
          }
          return { key: null, direction: "asc" };
        }
        return { key, direction: "asc" };
      });
    };

    const renderSortableHeader = (label, key) => {
      const isActive = sortConfig.key === key;
      const icon = !isActive
        ? "fa-sort"
        : sortConfig.direction === "asc"
          ? "fa-sort-up"
          : "fa-sort-down";
      return (
        <th
          scope="col"
          className={`${headerCellClass} pointer-cursor`}
          style={{ cursor: "pointer", whiteSpace: "nowrap", backgroundColor: "#f8f9fa" }}
          onClick={() => handleSort(key)}
        >
          {_t(t(label))}{" "}
          <i className={`fa ${icon}`} aria-hidden="true"></i>
        </th>
      );
    };
    sorting logic end */

    const viewHeaderRowStyle = {
      position: "sticky",
      top: "-2px",
      backgroundColor: "#f8f9fa",
      zIndex: 3,
      boxShadow: "0 1px 0 #dee2e6",
    };

    const TOTAL_COLUMNS = 17;

    const headerCellClass =
      "table-text text-capitalize align-middle text-center border-1 border text-nowrap";

    const cellClass = "table-text text-center align-middle text-nowrap";

    /* sorting logic start
    const renderSortableHeader = (label, key) => {
      const isActive = sortConfig.key === key;
      const icon = !isActive
        ? "fa-sort"
        : sortConfig.direction === "asc"
          ? "fa-sort-up"
          : "fa-sort-down";
      return (
        <th
          scope="col"
          className={`${headerCellClass} pointer-cursor`}
          style={{ cursor: "pointer", whiteSpace: "nowrap", backgroundColor: "#f8f9fa" }}
          onClick={() => handleSort(key)}
        >
          {_t(t(label))}{" "}
          <i className={`fa ${icon}`} aria-hidden="true"></i>
        </th>
      );
    };
    sorting logic end */

    const renderColumnHeaders = (sortable = false) => (
      <tr style={sortable ? viewHeaderRowStyle : undefined}>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("Group"))}</th>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("Ingredient Item"))}</th>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("Branch"))}</th>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("Consumed Qty"))}</th>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("UOM"))}</th>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("Consumed Qty - Converted"))}</th>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("UOM"))}</th>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("Purchase QTY"))}</th>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("UOM"))}</th>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("Purchased QTY - Converted"))}</th>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("UOM"))}</th>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("Variance"))}</th>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("Purchase Value"))}</th>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("Variance Qty %"))}</th>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("UOM"))}</th>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("Variance - Value"))}</th>
        <th scope="col" className={headerCellClass} style={sortable ? { backgroundColor: "#f8f9fa" } : undefined}>{_t(t("Variance %"))}</th>
        {/* sorting headers
        {sortable ? renderSortableHeader("Consumed Qty", "consumption_qty") : <th scope="col">{_t(t("Consumed Qty"))}</th>}
        {sortable ? renderSortableHeader("Consumed Qty - Converted", "consumption_qty_default") : <th scope="col">{_t(t("Consumed Qty - Converted"))}</th>}
        {sortable ? renderSortableHeader("Purchase QTY", "purchase_qty") : <th scope="col">{_t(t("Purchase QTY"))}</th>}
        {sortable ? renderSortableHeader("Purchased QTY - Converted", "purchase_qty_default") : <th scope="col">{_t(t("Purchased QTY - Converted"))}</th>}
        {sortable ? renderSortableHeader("Variance", "variance_qty") : <th scope="col">{_t(t("Variance"))}</th>}
        {sortable ? renderSortableHeader("Variance - Value", "variance_value") : <th scope="col">{_t(t("Variance - Value"))}</th>}
        {sortable ? renderSortableHeader("Variance %", "variance_percent") : <th scope="col">{_t(t("Variance %"))}</th>}
        */}
      </tr>
    );

    const renderRecordCells = (record) => (
      <>
        <td className={cellClass}>{formatTwoDecimal(record.consumption_qty)}</td>
        <td className={cellClass}>{record.consumption_uom}</td>
        <td className={cellClass}>{formatTwoDecimal(record.consumption_qty_default)}</td>
        <td className={cellClass}>{record.consumption_default_uom}</td>
        <td className={cellClass}>{formatTwoDecimal(record.purchase_qty)}</td>
        <td className={cellClass}>{record.purchase_uom}</td>
        <td className={cellClass}>{formatTwoDecimal(record.purchase_qty_default)}</td>
        <td className={cellClass}>{record.purchase_default_uom}</td>
        <td className={cellClass}>{formatTwoDecimal(record.variance_qty_default ?? record.variance_qty)}</td>
        <td className={cellClass}>{formatTwoDecimal(record.purchase_value ?? record.purchase_value)}</td>
        <td className={cellClass}>{formatTwoDecimal(record.variance_qty_percent ?? record.variance_qty_percent)}</td>
        <td className={cellClass}>{record.variance_default_uom ?? record.variance_uom}</td>
        <td className={cellClass}>{formatTwoDecimal(record.variance_value)}</td>
        <td className={cellClass}>{formatTwoDecimal(record.variance_percent)}</td>
      </>
    );

    const renderViewTableBody = () => {
      /* sorting logic start
      if (sortConfig.key) {
        return (
          <tbody className="align-middle">
            {getSortedViewRows().map((row, index) => (
              <tr key={`sorted-${index}`}>
                <td className={cellClass}>{row.groupName}</td>
                <td className={cellClass}>{row.itemName}</td>
                <td className={cellClass}>{row.record.branch}</td>
                {renderRecordCells(row.record)}
              </tr>
            ))}
          </tbody>
        );
      }
      sorting logic end */

      return (
        <tbody className="align-middle">
          {reportData && reportData.map((groupObj, groupIdx) => {
            return Object.keys(groupObj).map((groupName) => {
              let itemsArray = groupObj[groupName];
              return itemsArray.map((itemObj, itemIdx) => {
                return Object.keys(itemObj).map((itemName) => {
                  let branchesArray = itemObj[itemName];
                  return (
                    <React.Fragment key={`${groupIdx}-${itemIdx}`}>
                      <tr style={{ backgroundColor: "#eef3f7" }}>
                        <th className={cellClass}>{itemIdx === 0 ? groupName : ""}</th>
                        <th className={cellClass}>{itemName}</th>
                        <td className={cellClass} colSpan={TOTAL_COLUMNS - 2}></td>
                      </tr>
                      {branchesArray.map((record, index) => {
                        return (
                          <tr key={`${groupIdx}-${itemIdx}-${index}`}>
                            <td className={cellClass}></td>
                            <td className={cellClass}></td>
                            <td className={cellClass}>{record.branch}</td>
                            {renderRecordCells(record)}
                          </tr>
                        )
                      })}
                    </React.Fragment>
                  )
                })
              })
            })
          })}
        </tbody>
      );
    };

    const renderTableBody = () => (
      <tbody className="align-middle">
        {reportData && reportData.map((groupObj, groupIdx) => {
          return Object.keys(groupObj).map((groupName) => {
            let itemsArray = groupObj[groupName];
            return itemsArray.map((itemObj, itemIdx) => {
              return Object.keys(itemObj).map((itemName) => {
                let branchesArray = itemObj[itemName];
                return (
                  <React.Fragment key={`${groupIdx}-${itemIdx}`}>
                    <tr>
                      <th>{itemIdx === 0 ? groupName : ""}</th>
                      <th>{itemName}</th>
                      <td colSpan={TOTAL_COLUMNS - 2}></td>
                    </tr>
                    {branchesArray.map((record, index) => {
                      return (
                        <tr key={`${groupIdx}-${itemIdx}-${index}`}>
                          <td></td>
                          <td></td>
                          <td>{record.branch}</td>
                          {renderRecordCells(record)}
                        </tr>
                      )
                    })}
                  </React.Fragment>
                )
              })
            })
          })
        })}
      </tbody>
    );
  
    const handleGenerateReport = () => {
      if (
        (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
        !newReportFilter?.branch?.[0]?.id
      ) {
        toast.error(`${_t(t("Please select Branch to generate report"))}`, {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return;
      }
      setReportData(null);
      setGeneratedReport(false);
      // setSortConfig({ key: null, direction: "asc" });
      if (startDate !== null) {
        setLoading(true);
      
        let month = moment(startDate).format("MMMM");
        let year = parseInt(moment(startDate).format("YYYY"));

        let url = BASE_URL + "/settings/get-consumption-purchase-variance-report";
        
        let payload = {
          month: month,
          year: year,
          branch_id: newReportFilter?.branch?.length ? newReportFilter.branch.map(i => i.id) : [],
          group_ids: newReportFilter?.group?.length ? newReportFilter.group.map(i => i.id) : [],
          ingredient_item_ids: newReportFilter?.item?.length ? newReportFilter.item.map(i => i.id) : []
        };

        return axios
          .post(url, payload, {
            headers: { Authorization: `Bearer ${getCookie()}` },
          })
          .then((res) => {
            setLoading(false);
            setGeneratedReport(true);
            setReportData(res.data.result);
          })
          .catch((error) => {
            setLoading(false);
          });
      } else {
        toast.error(
          `${_t(t("Please select a month"))}`,
          {
            position: "bottom-center",
            closeButton: false,
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }
        );
      }
    };

  return (
    <>
    <Helmet>
      <title>{_t(t("Consumption Purchase Variance Report"))}</title>
    </Helmet>
    <ReactHTMLTableToExcel
      id="test-table-xls-button"
      className="download-table-xls-button btn btn-success float-right mr-3 invisible"
      table="table-to-xls"
      filename="Consumption Purchase Variance Report"
      sheet="sheet 1"
      buttonText="Download Details"
      ref={componentRef}
    />

    {/* main body */}
    <main id="main" data-simplebar>
      <div className="container-fluid">
        <div className="row t-mt-10 gx-2">
          {/* left Sidebar */}
          <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
            <ReportSidebar />
          </div>
          {/* left Sidebar ends */}

          {/* Rightbar contents */}
          <div className="col-lg-10 col-xxl-10 t-mb-2 mb-lg-0">
            <div className="t-bg-white p-1">
              <div
                className="fk-scroll--pos-menu table-bottom-info-hide"
                data-simplebar
              >
                <div className="t-pl-15 t-pr-15">
                  <CustomSpinLoader loading={dataPaginating || loading}/>
                   <>
                    <div key="smtp-form mt-2">
                      <div className="row mt-1 gx-2 align-items-center t-pt-2 t-pb-2">
                        <div className="col-12 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize mt-2">
                                {_t(t("Consumption Purchase Variance Report"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row gx-2 mt-2">
                        <div className="col-2 mt-1">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                            className="form-control sm-text py-2 t-mb-2 mb-md-0"
                            placeholderText={_t(t("Select Month"))}
                            shouldCloseOnSelect={true}
                          />
                        </div>

                        <div className="col-3 mt-1">
                          <Select
                            options={branchSearch && branchSearch}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isClearable
                            value={newReportFilter?.branch ?? ""}
                            isMulti
                            classNamePrefix="select"
                            styles={customStyle}
                            className="sm-text "
                            onChange={handleBranch}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select branches")) + ".."}
                          />
                        </div>

                        <div className="col-2 mt-1">
                          <Select
                            options={ingredientGroupForSearch ? ingredientGroupForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isClearable
                            value={newReportFilter?.group ?? ""}
                            isMulti
                            classNamePrefix="select"
                            className="sm-text"
                            styles={customStyle}
                            onChange={handleGroup}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select groups")) + ".."}
                          />
                        </div>

                        <div className="col-3 mt-1">
                          <Select
                            options={ingredientItemForSearch && ingredientItemForSearch}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isClearable
                            value={newReportFilter?.item ?? ""}
                            isMulti
                            classNamePrefix="select"
                            className="sm-text"
                            styles={customStyle}
                            onChange={handleItem}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select items")) + ".."}
                          />
                        </div>
                        <div className="col-2 mt-1">
                          <button
                          className="btn-primary btn-block text-uppercase sm-text py-2 rounded border-0"
                          onClick={(e) => handleGenerateReport(e)}
                          >
                            Generate Report
                          </button>
                        </div>
                      </div>

                      {generatedReport && reportData && (
                        <>
                          <div className="d-flex align-items-center mt-3">
                            <button
                              type="button"
                              className="btn btn-success sm-text mr-2"
                              onClick={() => componentRef.current?.handleDownload()}
                            >
                              <i className="fa fa-table" aria-hidden="true"></i>{" "}
                              {_t(t("Excel"))}
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary sm-text"
                              onClick={thermalPrint}
                            >
                              <i className="fa fa-print" aria-hidden="true"></i>{" "}
                              {_t(t("Print"))}
                            </button>
                          </div>
                          <div className="row gx-2 justify-content-center t-pt-10 t-pb-10">
                            <div
                              className="col-12 t-mb-15 mb-md-0 table-responsive"
                              style={{
                                maxHeight: "calc(100vh - 280px)",
                                overflow: "auto",
                                scrollbarWidth: "thin",
                                scrollbarColor: "#94a3b8 #edf2f7",
                              }}
                            >
                              <table
                                className="table table-bordered table-hover mb-0"
                                style={{ fontSize: "14px" }}
                              >
                                <thead className="align-middle">
                                  {renderColumnHeaders(true)}
                                </thead>
                                {renderViewTableBody()}
                              </table>
                            </div>
                          </div>
                          <div className="d-none">
                            <div ref={componentRefThermal}>
                              <table
                                className="table table-bordered table-hover"
                                id="table-to-xls"
                              >
                                <thead className="align-middle">
                                  <tr style={{ border: "0px" }}>
                                    <th colSpan={TOTAL_COLUMNS} style={{ border: "0px" }}>
                                      <div className="row">
                                        <div className="col-12">
                                          <h3 className="text-center mb-0">
                                            {siteName}
                                          </h3>
                                          <h3 className="text-center mt-0">
                                            Consumption Purchase Variance Report
                                          </h3>
                                          <p className="text-center">
                                            MONTH&nbsp;
                                            <Moment format="MMMM YYYY">
                                              {startDate}
                                            </Moment>
                                          </p>
                                        </div>
                                      </div>
                                    </th>
                                  </tr>
                                  {renderColumnHeaders()}
                                </thead>
                                {renderTableBody()}
                                <tfoot style={{ border: "0px" }}>
                                  <tr style={{ border: "0px" }}>
                                    <td
                                      colSpan={TOTAL_COLUMNS}
                                      className="text-center"
                                      style={{ border: "0px" }}
                                    >
                                      <h5 className="mt-3">
                                        Powered by indolj.pk
                                      </h5>
                                    </td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                   </>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </>
  );
};

export default StockConsumptionPurchaseVarianceReport;
